// import React, { useState, useEffect } from 'react';
// import {
// 	TextField,
// 	Button,
// 	Container,
// 	Box,
// 	Dialog,
// 	DialogTitle,
// 	DialogContent,
// 	DialogActions,
// 	IconButton,
// 	Autocomplete,
// 	Checkbox,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { ServiceProduct } from 'types/serviceProduct';
// import { createPlan, createPlanField } from '../../services/api/PlansAPI';
// import { getAllICon } from '../../services/api/OttIcon';
// import CreateIcon from '../../components/forms/CreateIcon';
// import { Icons } from '../../types/icons'; // Import the Icons type
// import { hover } from '@testing-library/user-event/dist/hover';

// interface ServiceProductFormProps {
// 	serviceProduct?: ServiceProduct;
// 	open: boolean;
// 	handleClose: () => void;
// 	productNameProvide: 'Airtel' | 'Jio' | 'Vi' | 'Tata';
// 	onSuccess: () => void;
// 	planId: string;
// }

// interface PlanFieldStructureDevelop {
// 	label: string;
// 	value: string;
// 	type: string;
// 	_id?: string;
// }

// interface Plans {
// 	fieldDefinitions: PlanFieldStructureDevelop[];
// 	_id?: string;
// }

// interface OttApp {
// 	_id: string;
// 	name: string;
// 	imageUrl: string;
// }

// const PlanCreation: React.FC<ServiceProductFormProps> = ({
// 	serviceProduct,
// 	open,
// 	handleClose,
// 	productNameProvide,
// 	onSuccess,
// 	planId,
// }) => {
// 	const [formData, setFormData] = useState<PlanFieldStructureDevelop[]>([]);
// 	// const [initialLabel, setInitialLabel] = useState<string>('');
// 	const [loading, setLoading] = useState(false);
// 	const [ottApps, setOttApps] = useState<OttApp[]>([]);
// 	const [selectedOttApps, setSelectedOttApps] = useState<OttApp[]>([]);
// 	const [openForm, setOpenForm] = useState(false);
// 	const [price, setPrice] = useState<string>('');
// 	const [validity, setValidity] = useState<string>('');
// 	const [offer, setOffer] = useState<string>('');
// 	const [internetSpeed, setInternetSpeed] = useState<string>('');
// 	const [selectedIcon, setSelectedIcon] = useState<Icons | null>(null); // Define selectedIcon if needed
// 	console.log('serviceProduct-------------->', serviceProduct);
// 	const handleIconSelect = (icon: Icons) => {
// 		setSelectedIcon(icon);
// 	};

// 	const fetchOttApps = async () => {
// 		try {
// 			const response = await getAllICon();
// 			if (response.success) {
// 				setOttApps(response.data.ottApps);
// 			}
// 		} catch (error) {
// 			console.log(error);
// 		}
// 	};

// 	useEffect(() => {
// 		const fetchData = async () => {
// 			try {
// 				setLoading(true);
// 				if (serviceProduct?.plans && 'fieldDefinitions' in serviceProduct.plans) {
// 					const plans = serviceProduct.plans as Plans;
// 					const fieldDefinitions = plans.fieldDefinitions.map((field) => ({
// 						label: field.label,
// 						value: field.value,
// 						type: field.type,
// 						_id: field._id,
// 					}));
// 					setFormData(fieldDefinitions);
// 				}
// 				await fetchOttApps();
// 			} catch (error) {
// 				console.log(error);
// 			} finally {
// 				setLoading(false);
// 			}
// 		};
// 		fetchData();
// 	}, [serviceProduct]);

// 	const handleSubmit = async (event: React.FormEvent) => {
// 		event.preventDefault();
// 		try {
// 			setLoading(true);
// 			if (serviceProduct?._id) {
// 				const formDataToSend = new FormData();

// 				// Convert fieldDefinitions to a JSON string and append it to FormData
// 				const fieldDefinitionsJson = JSON.stringify(
// 					formData.map((field) => ({
// 						label: field.label,
// 						value: field.value || 'NA',
// 					}))
// 				);
// 				formDataToSend.append('fieldDefinitions', fieldDefinitionsJson);

// 				// Append other fields
// 				formDataToSend.append('planId', planId ? planId : '');
// 				formDataToSend.append('offer', offer ? offer : '');
// 				formDataToSend.append('price', price ? price : '');
// 				formDataToSend.append('validity', validity ? validity : '');
// 				formDataToSend.append('internetSpeed', internetSpeed ? internetSpeed : '');
// 				formDataToSend.append(
// 					'ottApps',
// 					JSON.stringify(selectedOttApps.map((app) => app._id))
// 				);

// 				if (Object.keys(serviceProduct?.plans || {}).length > 0) {
// 					const response = await createPlan(formDataToSend);
// 					if (response.success) {
// 						toast.success(response.message ? response.message : 'Successfully updated');
// 						onSuccess();
// 						// setInitialLabel('');
// 						setTimeout(() => {
// 							handleDialogClose();
// 						}, 3000);
// 					} else {
// 						toast.error(
// 							response.data.message ? response?.data.message : 'Something went wrong'
// 						);
// 					}
// 				} else {
// 					const response = await createPlanField({
// 						serviceId: serviceProduct._id,
// 						fieldDefinitions: formData.map((field) => ({
// 							label: field.label,
// 							type: field.type,
// 						})),
// 					});
// 					if (response.success) {
// 						toast.success(response.message ? response.message : 'Successfully created');
// 						// setInitialLabel('');
// 						onSuccess();
// 						setTimeout(() => {
// 							handleDialogClose();
// 						}, 3000);
// 					} else {
// 						toast.error(
// 							response.data.message ? response?.data.message : 'Something went wrong'
// 						);
// 					}
// 				}
// 			}
// 		} catch (error) {
// 			console.log(error);
// 		} finally {
// 			setLoading(false);
// 		}
// 	};

// 	const handleDialogClose = () => {
// 		setFormData([]);
// 		// setInitialLabel('');
// 		handleClose();
// 	};

// 	const handleOpenForm = () => {
// 		setOpenForm(true);
// 	};

// 	const handleCloseForm = () => {
// 		setOpenForm(false);
// 		fetchOttApps();
// 	};

// 	const handleToggleOttApp = (app: OttApp) => {
// 		setSelectedOttApps((prevSelected) => {
// 			if (prevSelected.some((selectedApp) => selectedApp._id === app._id)) {
// 				// If the app is already selected, remove it
// 				return prevSelected.filter((selectedApp) => selectedApp._id !== app._id);
// 			} else {
// 				// Otherwise, add it to the selection
// 				return [...prevSelected, app];
// 			}
// 		});
// 	};

// 	return (
// 		<Dialog
// 			open={open}
// 			slotProps={{
// 				paper: {
// 					sx: {
// 						minWidth: 300,
// 						maxWidth: 600,
// 						width: '90%',
// 					},
// 				},
// 			}}
// 		>
// 			<ToastContainer />
// 			<DialogTitle variant="h3" style={{ borderBottom: '1px solid gray' }}>
// 				{/* {Object.keys(serviceProduct?.plans || {}).length > 0
// 					? `Update ${productNameProvide} Plan`
// 					: `Create ${productNameProvide} Plan`} */}
// 				{`Create ${productNameProvide} Plan`}
// 				<IconButton
// 					aria-label="close"
// 					onClick={handleDialogClose}
// 					sx={{ position: 'absolute', right: 8, top: 8 }}
// 				>
// 					<CloseIcon />
// 				</IconButton>
// 			</DialogTitle>
// 			<DialogContent>
// 				<Container>
// 					<Box sx={{ mt: 0 }}>
// 						<form onSubmit={handleSubmit}>
// 							<TextField
// 								label="Offer"
// 								value={offer}
// 								fullWidth
// 								margin="normal"
// 								size="small"
// 								onChange={(e) => {
// 									setOffer(e.target.value);
// 								}}
// 							/>

// 							<TextField
// 								label="Price"
// 								required
// 								type="text"
// 								value={price}
// 								fullWidth
// 								margin="normal"
// 								size="small"
// 								slotProps={{
// 									input: {
// 										// Use `inputProps` inside `slotProps.input` to apply raw HTML attributes
// 										inputProps: {
// 											inputMode: 'numeric',
// 											pattern: '[0-9]*',
// 										},
// 									},
// 								}}
// 								onChange={(e) => {
// 									const newValue = e.target.value;
// 									if (/^\d*$/.test(newValue)) {
// 										setPrice(newValue);
// 									}
// 								}}
// 							/>
// 							{!serviceProduct?.isDTH && (
// 								<>
// 									<TextField
// 										label="Validity"
// 										value={validity}
// 										fullWidth
// 										margin="normal"
// 										size="small"
// 										onChange={(e) => {
// 											setValidity(e.target.value);
// 										}}
// 									/>
// 									<TextField
// 										label="Internet Speed"
// 										value={internetSpeed}
// 										fullWidth
// 										margin="normal"
// 										size="small"
// 										onChange={(e) => {
// 											setInternetSpeed(e.target.value);
// 										}}
// 									/>
// 									{formData.map((field, index) => (
// 										<TextField
// 											key={index}
// 											label={field.label}
// 											value={field.value}
// 											fullWidth
// 											margin="normal"
// 											size="small"
// 											onChange={(e) => {
// 												const updatedFormData = [...formData];
// 												updatedFormData[index].value = e.target.value;
// 												setFormData(updatedFormData);
// 											}}
// 										/>
// 									))}
// 									<Autocomplete
// 										multiple
// 										options={ottApps}
// 										getOptionLabel={(option) => option.name}
// 										value={selectedOttApps}
// 										onChange={(event, newValue) => {
// 											setSelectedOttApps(newValue);
// 										}}
// 										disableClearable
// 										renderOption={(props, option, { selected }) => (
// 											<li
// 												{...props}
// 												onClick={() => handleToggleOttApp(option)}
// 											>
// 												<Checkbox checked={selected} />
// 												<img
// 													src={option.imageUrl}
// 													alt={option.name}
// 													style={{
// 														width: 20,
// 														height: 20,
// 														marginRight: 10,
// 													}}
// 												/>
// 												{option.name}
// 											</li>
// 										)}
// 										renderTags={(tagValue, getTagProps) =>
// 											tagValue.map((option, index) => (
// 												<div
// 													key={index}
// 													style={{
// 														display: 'flex',
// 														alignItems: 'center',
// 														backgroundColor: '#7159c1',
// 														borderRadius: 20,
// 														padding: '4px 10px',
// 														marginRight: 5,
// 														color: 'white',
// 														marginBottom: 5,
// 													}}
// 												>
// 													<img
// 														src={option.imageUrl}
// 														alt={option.name}
// 														style={{
// 															width: 20,
// 															height: 20,
// 															borderRadius: '50%',
// 															marginRight: 6,
// 														}}
// 													/>
// 													<span style={{ marginRight: 6 }}>
// 														{option.name}
// 													</span>
// 													<IconButton
// 														size="small"
// 														onClick={() => {
// 															const newTags = selectedOttApps.filter(
// 																(item) => item.name !== option.name
// 															);
// 															setSelectedOttApps(newTags);
// 														}}
// 														sx={{
// 															color: 'white',
// 															backgroundColor: '#ccc',
// 															'&:hover': {
// 																backgroundColor: 'primary.main',
// 															},
// 														}}
// 														// style={{ color: 'white', padding: 0 }}
// 													>
// 														<CloseIcon fontSize="small" />
// 													</IconButton>
// 												</div>
// 											))
// 										}
// 										renderInput={(params) => (
// 											<TextField
// 												{...params}
// 												label="OTT Apps"
// 												placeholder="Search OTT Apps"
// 											/>
// 										)}
// 									/>
// 									<Button
// 										onClick={handleOpenForm}
// 										variant="contained"
// 										color="primary"
// 									>
// 										Add New Icon
// 									</Button>
// 								</>
// 							)}
// 							<DialogActions>
// 								<Button
// 									onClick={handleDialogClose}
// 									color="secondary"
// 									variant="outlined"
// 								>
// 									Cancel
// 								</Button>

// 								<Button
// 									type="submit"
// 									variant="contained"
// 									color="primary"
// 									disabled={
// 										loading || serviceProduct?.isDTH
// 											? false
// 											: formData.length === 0 ||
// 												formData.some((field) => field.label.trim() === '')
// 									}
// 								>
// 									Submit
// 								</Button>
// 							</DialogActions>
// 						</form>
// 					</Box>
// 				</Container>
// 			</DialogContent>
// 			<CreateIcon
// 				open={openForm}
// 				handleClose={handleCloseForm}
// 				fetchCategories={fetchOttApps}
// 				iconData={selectedIcon}
// 			/>
// 		</Dialog>
// 	);
// };

// export default PlanCreation;
// ==========================================================================================================================
// ==========================================================================================================================
// ==========================================================================================================================
// ==========================================================================================================================
// ==========================================================================================================================
// ==========================================================================================================================
// ==========================================================================================================================
// ==========================================================================================================================
// ==========================================================================================================================
// ==========================================================================================================================
// ==========================================================================================================================
// ==========================================================================================================================
// ==========================================================================================================================
// ==========================================================================================================================
// ==========================================================================================================================
// ==========================================================================================================================
// ==========================================================================================================================
// ==========================================================================================================================import React, { useState, useEffect, useRef } from 'react';
import React, { useState, useEffect, useRef } from 'react';
import {
	TextField,
	Button,
	Container,
	Box,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	IconButton,
	Autocomplete,
	Checkbox,
	Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ServiceProduct } from 'types/serviceProduct';
import { createPlan, createPlanField } from '../../services/api/PlansAPI';
import { getAllICon } from '../../services/api/OttIcon';
import CreateIcon from '../../components/forms/CreateIcon';
// import { Icons } from '../../types/icons';

interface ServiceProductFormProps {
	serviceProduct?: ServiceProduct;
	open: boolean;
	handleClose: () => void;
	productNameProvide: 'Airtel' | 'Jio' | 'Vi' | 'Tata';
	onSuccess: () => void;
	planId: string;
}

interface PlanFieldStructureDevelop {
	label: string;
	value: string;
	type: string;
	_id?: string;
}

interface Plans {
	fieldDefinitions: PlanFieldStructureDevelop[];
	_id?: string;
}

interface OttApp {
	_id: string;
	name: string;
	imageUrl: string;
}

const PlanCreation: React.FC<ServiceProductFormProps> = ({
	serviceProduct,
	open,
	handleClose,
	productNameProvide,
	onSuccess,
	planId,
}) => {
	const [formData, setFormData] = useState<PlanFieldStructureDevelop[]>([]);
	const [loading, setLoading] = useState(false);
	const [ottApps, setOttApps] = useState<OttApp[]>([]);
	const [selectedOttApps, setSelectedOttApps] = useState<OttApp[]>([]);
	const [openForm, setOpenForm] = useState(false);
	const [price, setPrice] = useState<string>('');
	const [validity, setValidity] = useState<string>('');
	const [offer, setOffer] = useState<string>('');
	const [internetSpeed, setInternetSpeed] = useState<string>('');
	// const [selectedIcon, setSelectedIcon] = useState<Icons | null>(null);
	const [offerImage, setOfferImage] = useState<File[]>([]);
	const fileInputRef = useRef<HTMLInputElement>(null);
	const [responseStatus, setResponseStatus] = useState(true);
	const [responseStatusMessage, setResponseStatusMessage] = useState(
		'Failed to fetch plan details'
	);

	// const handleIconSelect = (icon: Icons) => {
	// 	setSelectedIcon(icon);
	// };

	const fetchOttApps = async () => {
		try {
			const response = await getAllICon();
			if (response.success) {
				setOttApps(response.data.ottApps);
			}
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		const fetchData = async () => {
			try {
				// setLoading(true);
				if (serviceProduct?.plans && 'fieldDefinitions' in serviceProduct.plans) {
					const plans = serviceProduct.plans as Plans;
					const fieldDefinitions = plans.fieldDefinitions.map((field) => ({
						label: field.label,
						value: field.value,
						type: field.type,
						_id: field._id,
					}));
					setFormData(fieldDefinitions);
				}
				await fetchOttApps();
			} catch (error) {
				console.log(error);
			}
			// finally {
			// setLoading(false);
			// }
		};
		fetchData();
	}, [serviceProduct]);

	const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.files) {
			const files = Array.from(event.target.files);
			const validFiles: File[] = [];

			files.forEach((file) => {
				const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
				const maxSize = 5 * 1024 * 1024; // 5MB

				if (validTypes.includes(file.type) && file.size <= maxSize) {
					validFiles.push(file);
				} else {
					toast.error(
						`Invalid file type or size for ${file.name}. Only JPEG, PNG, JPG are allowed and max size is 5MB.`
					);
				}
			});

			if (validFiles.length > 0) {
				setOfferImage((prevImages) => [...prevImages, ...validFiles].slice(0, 10));
			}
		}
	};

	const handleRemoveImage = (index: number) => {
		setOfferImage((prevImages) => prevImages.filter((_, i) => i !== index));
	};

	const handleSubmit = async (event: React.FormEvent) => {
		event.preventDefault();
		try {
			setLoading(true);
			if (serviceProduct?._id) {
				const formDataToSend = new FormData();

				const fieldDefinitionsJson = JSON.stringify(
					formData.map((field) => ({
						label: field.label,
						value: field.value || 'NA',
					}))
				);
				formDataToSend.append('fieldValues', fieldDefinitionsJson);

				formDataToSend.append('planId', planId ? planId : '');
				formDataToSend.append('offer', offer ? offer : '');
				formDataToSend.append('price', price ? price : '');
				formDataToSend.append('validity', validity ? validity : '');
				formDataToSend.append('internetSpeed', internetSpeed ? internetSpeed : '');
				formDataToSend.append(
					'ottApps',
					JSON.stringify(selectedOttApps.map((app) => app._id))
				);

				// if (serviceProduct?.isDTH) {
				offerImage.forEach((image) => {
					formDataToSend.append('offerImages', image);
				});
				// }

				if (Object.keys(serviceProduct?.plans || {}).length > 0) {
					console.log('formDataToSend', formDataToSend);
					const response = await createPlan(formDataToSend);
					if (response.success) {
						toast.success(response.message ? response.message : 'Successfully updated');
						onSuccess();
						setTimeout(() => {
							handleDialogClose();
						}, 3000);
					} else {
						setResponseStatus(false);
						setResponseStatusMessage('Failed to fetch plan details.');
						toast.error(
							response.data.message ? response?.data.message : 'Something went wrong'
						);
					}
				} else {
					const response = await createPlanField({
						serviceId: serviceProduct._id,
						fieldDefinitions: formData.map((field) => ({
							label: field.label,
							type: field.type,
						})),
					});
					if (response.success) {
						toast.success(response.message ? response.message : 'Successfully created');
						onSuccess();
						setTimeout(() => {
							handleDialogClose();
						}, 3000);
					} else {
						setResponseStatus(false);
						setResponseStatusMessage('Failed to fetch plan details.');
						toast.error(
							response.data.message ? response?.data.message : 'Something went wrong'
						);
						setLoading(false);
					}
				}
			}
		} catch (error) {
			setLoading(false);
			console.log(error);
		}
		// finally {

		// }
	};

	const handleDialogClose = () => {
		handleClose();
		setPrice('');
		setInternetSpeed('');
		setOffer('');
		setValidity('');
		setSelectedOttApps([]);
		setFormData([]);
	};

	const handleOpenForm = () => {
		setOpenForm(true);
	};

	const handleCloseForm = () => {
		setOpenForm(false);
		fetchOttApps();
	};

	const handleToggleOttApp = (app: OttApp) => {
		setSelectedOttApps((prevSelected) => {
			if (prevSelected.some((selectedApp) => selectedApp._id === app._id)) {
				return prevSelected.filter((selectedApp) => selectedApp._id !== app._id);
			} else {
				return [...prevSelected, app];
			}
		});
	};

	return (
		<Dialog
			open={open}
			slotProps={{
				paper: {
					sx: {
						minWidth: 300,
						maxWidth: 600,
						width: '90%',
					},
				},
			}}
		>
			<ToastContainer />
			<DialogTitle variant="h3" style={{ borderBottom: '1px solid gray' }}>
				{`Create ${productNameProvide} Plan`}
				<IconButton
					aria-label="close"
					onClick={handleDialogClose}
					sx={{ position: 'absolute', right: 8, top: 8 }}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<Container>
					{responseStatus ? (
						<Box sx={{ mt: 0 }}>
							<form onSubmit={handleSubmit}>
								<TextField
									label="Offer"
									value={offer}
									fullWidth
									margin="normal"
									size="small"
									onChange={(e) => {
										setOffer(e.target.value);
									}}
								/>

								<TextField
									label="Price"
									required
									type="text"
									value={price}
									fullWidth
									margin="normal"
									size="small"
									slotProps={{
										input: {
											inputProps: {
												inputMode: 'numeric',
												pattern: '[0-9]*',
											},
										},
									}}
									onChange={(e) => {
										const newValue = e.target.value;
										if (/^\d*$/.test(newValue)) {
											setPrice(newValue);
										}
									}}
								/>
								{serviceProduct?.isDTH ? (
									<div
										style={{
											marginTop: '15px',
											width: '520px',
											maxWidth: '600px',
											minWidth: '300px',
										}}
									>
										<input
											multiple
											type="file"
											ref={fileInputRef}
											onChange={handleImageChange}
											accept="image/jpeg, image/png, image/jpg"
											style={{ display: 'none' }}
										/>
										<Button
											variant="contained"
											component="span"
											onClick={() => fileInputRef.current?.click()}
										>
											Upload DTH offer plan image
										</Button>
										<Typography
											style={{
												color: '#8f8e8e',
												paddingLeft: '5px',
												fontSize: '14px',
											}}
										>
											{/* <br /> */}
											Upload the image up to 5MB Size and should be JPEG, JPG
											or PNG
										</Typography>
										{/* {offerImage.length > 0 && (
										<div style={{ marginTop: '10px' }}>
											{offerImage.map((image, index) => (
												<div
													key={index}
													style={{
														position: 'relative',
														marginBottom: '10px',
													}}
												>
													<img
														src={URL.createObjectURL(image)}
														alt={`Preview ${index}`}
														// style={{ width: '100%' }}
														style={{ width: '250px',height:"300px" }}
													/>
													<IconButton
														aria-label="remove image"
														onClick={() => handleRemoveImage(index)}
														sx={{
															position: 'absolute',
															right: 0,
															top: 0,
														}}
													>
														<CloseIcon />
													</IconButton>
												</div>
											))}
										</div>
									)} */}
										{/* {offerImage.length > 0 && (
										<div
											style={{
												marginTop: '10px',
												display: 'grid',
												gridTemplateColumns:
													'repeat(auto-fill, minmax(250px, 1fr))',
												gap: '10px',
											}}
										>
											{offerImage.map((image, index) => (
												<div
													key={index}
													style={{
														position: 'relative',
														marginBottom: '10px',
													}}
												>
													<img
														src={URL.createObjectURL(image)}
														alt={`Preview ${index}`}
														style={{
															width: '250px',
															height: '300px',
															objectFit: 'cover',
														}}
													/>
													<IconButton
														aria-label="remove image"
														onClick={() => handleRemoveImage(index)}
														sx={{
															position: 'absolute',
															right: 0,
															top: 0,
															backgroundColor:
																'rgba(255, 255, 255, 0.7)',
														}}
													>
														<CloseIcon />
													</IconButton>
												</div>
											))}
										</div>
									)} */}
										{offerImage.length > 0 && (
											<div
												style={{
													marginTop: '10px',
													display: 'flex',
													flexWrap: 'wrap',
													gap: '3px',
												}}
											>
												{offerImage.map((image, index) => (
													<div
														key={index}
														style={{
															position: 'relative',
															width: '250px',
															height: '300px',
														}}
													>
														<img
															src={URL.createObjectURL(image)}
															alt={`Preview ${index}`}
															style={{
																width: '100%',
																height: '100%',
																objectFit: 'contain',
															}}
														/>
														<IconButton
															aria-label="remove image"
															onClick={() => handleRemoveImage(index)}
															sx={{
																position: 'absolute',
																right: 0,
																top: 0,
																backgroundColor:
																	'rgba(160, 158, 158, 0.7)',
															}}
														>
															<CloseIcon />
														</IconButton>
													</div>
												))}
											</div>
										)}
									</div>
								) : (
									<>
										<TextField
											label="Validity"
											value={validity}
											fullWidth
											margin="normal"
											size="small"
											onChange={(e) => {
												setValidity(e.target.value);
											}}
										/>
										<TextField
											label="Internet Speed"
											value={internetSpeed}
											fullWidth
											margin="normal"
											size="small"
											onChange={(e) => {
												setInternetSpeed(e.target.value);
											}}
										/>
										{formData.map((field, index) => (
											<TextField
												key={index}
												label={field.label}
												value={field.value}
												fullWidth
												margin="normal"
												size="small"
												onChange={(e) => {
													const updatedFormData = [...formData];
													updatedFormData[index].value = e.target.value;
													setFormData(updatedFormData);
												}}
											/>
										))}
										<Autocomplete
											multiple
											options={ottApps}
											getOptionLabel={(option) => option.name}
											value={selectedOttApps}
											onChange={(event, newValue) => {
												setSelectedOttApps(newValue);
											}}
											disableClearable
											renderOption={(props, option, { selected }) => (
												<li
													{...props}
													onClick={() => handleToggleOttApp(option)}
												>
													<Checkbox checked={selected} />
													<img
														src={option.imageUrl}
														alt={option.name}
														style={{
															width: 20,
															height: 20,
															marginRight: 10,
														}}
													/>
													{option.name}
												</li>
											)}
											renderTags={(tagValue) =>
												tagValue.map((option, index) => (
													<div
														key={index}
														style={{
															display: 'flex',
															alignItems: 'center',
															backgroundColor: '#7159c1',
															borderRadius: 20,
															padding: '4px 10px',
															marginRight: 5,
															color: 'white',
															marginBottom: 5,
														}}
													>
														<img
															src={option.imageUrl}
															alt={option.name}
															style={{
																width: 20,
																height: 20,
																borderRadius: '50%',
																marginRight: 6,
															}}
														/>
														<span style={{ marginRight: 6 }}>
															{option.name}
														</span>
														<IconButton
															size="small"
															onClick={() => {
																const newTags =
																	selectedOttApps.filter(
																		(item) =>
																			item.name !==
																			option.name
																	);
																setSelectedOttApps(newTags);
															}}
															sx={{
																color: 'white',
																backgroundColor: '#ccc',
																'&:hover': {
																	backgroundColor: 'primary.main',
																},
															}}
														>
															<CloseIcon fontSize="small" />
														</IconButton>
													</div>
												))
											}
											renderInput={(params) => (
												<TextField
													{...params}
													label="OTT Apps"
													placeholder="Search OTT Apps"
												/>
											)}
										/>
										<Button
											onClick={handleOpenForm}
											variant="contained"
											color="primary"
										>
											Add New Icon
										</Button>
									</>
								)}
								<DialogActions>
									<Button
										onClick={handleDialogClose}
										color="secondary"
										variant="outlined"
									>
										Cancel
									</Button>

									{loading ? (
										<Button
											type="submit"
											variant="contained"
											color="primary"
											disabled={true}
										>
											Submit
										</Button>
									) : (
										<Button
											type="submit"
											variant="contained"
											color="primary"
											disabled={
												loading || serviceProduct?.isDTH
													? false
													: formData.length === 0 ||
														formData.some(
															(field) => field.label.trim() === ''
														)
											}
										>
											Submit
										</Button>
									)}
								</DialogActions>
							</form>
						</Box>
					) : (
						<Box sx={{ mt: 0 }}>
							<Typography
								variant="h6"
								sx={{
									mt: 2,
									textAlign: 'center',
									color: 'red',
									fontWeight: 'bold',
									height: '200px',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								{responseStatusMessage}
							</Typography>
						</Box>
					)}
				</Container>
			</DialogContent>
			<CreateIcon
				open={openForm}
				handleClose={handleCloseForm}
				fetchCategories={fetchOttApps}
				// iconData={selectedIcon}
			/>
		</Dialog>
	);
};

export default PlanCreation;
